export function getQueryParams(url) {
    const queryParams = {};
    const queryIndex = url.indexOf('?');
    if (queryIndex === -1) {
        return queryParams;
    }
    const queryString = url.substring(queryIndex + 1);
    const pairs = queryString.split('&');
    for (let i = 0; i < pairs.length; i++) {
        const [key, value] = pairs[i].split('=');
        queryParams[decodeURIComponent(key)] = decodeURIComponent(value);
    }
    return queryParams;
}
//# sourceMappingURL=common.js.map